import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from '@/plugins/vue-i18n'
import vuetify from '@/plugins/vuetify'
import ApiService from '@/services/api.service'
import ReportsApiService from '@/services/reportsApi.service'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import '@/plugins/globalComponents'
import '@/plugins/vue-multiselect'
import '@/plugins/autocomplete'
import '@/helpers/vue-filters'
import '@/plugins/directives'
import '@/plugins/vue-mask'
import '@/plugins/v-tootip'
import '@/plugins/moment'

Vue.config.productionTip = false

Vue.component('vue-select', vSelect)
Vue.http = Vue.prototype.$http = ApiService
Vue.prototype.$reportsHttp = ReportsApiService
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
